const publicSiteUrl = "https://veronics.org";
const aboutPageUrl = `${publicSiteUrl}/about-us`;

export const aboutEntityDefinition =
  "Veronics is operating software that runs enrollment, class schedules, family records, and tuition tracking for homeschool co-ops, microschools, hybrid programs, enrichment groups, and other small learning communities.";

export const aboutPageFaqs = [
  {
    question: "What is Veronics?",
    answer: `${aboutEntityDefinition} It brings enrollment, schedules, family and student records, tuition, and recorded payments into workflows that fit each program.`,
  },
  {
    question: "What does Veronics help programs manage?",
    answer:
      "Veronics helps program administrators manage applications, enrollment, classes, schedules, family records, student records, tuition, fees, and recorded payments. The platform also includes operational forms and self-service public website and content-management tools.",
  },
  {
    question: "Who is Veronics for?",
    answer:
      "Veronics is for administrators and program leaders at homeschool co-ops, microschools, hybrid programs, enrichment groups, and other small learning communities. Families and teachers use the shared workflows for the parts of the program that involve them.",
  },
  {
    question: "How is Veronics different from district-sized school software?",
    answer:
      "Veronics is designed for small learning communities that need more structure without adopting a district model. Its workflows reflect the program's own enrollment rules, class schedules, family records, and tuition practices.",
  },
  {
    question: "How much does Veronics cost?",
    answer: "Pricing details are coming soon.",
  },
  {
    question: "How did Veronics begin?",
    answer:
      "Veronics began in 2025 after founder Dane Vanderbilt worked with a local learning community whose registration process crossed email, forms, and spreadsheets. The platform launched with that community in 2025 and continues to develop through questions and feedback from using it.",
  },
] as const;

export const aboutPageStructuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${aboutPageUrl}#organization`,
      name: "Veronics",
      url: publicSiteUrl,
      logo: `${publicSiteUrl}/veronics_greenblack.png`,
      description: aboutEntityDefinition,
      foundingDate: "2025",
      founder: {
        "@type": "Person",
        name: "Dane Vanderbilt",
        jobTitle: "Founder of Veronics",
        url: "https://danevanderbilt.com",
      },
      sameAs: [
        "https://www.facebook.com/profile.php?id=61577022772656",
        "https://www.instagram.com/hello.veronics/",
        "https://www.linkedin.com/company/veronics/",
      ],
    },
    {
      "@type": "SoftwareApplication",
      "@id": `${aboutPageUrl}#software`,
      name: "Veronics",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      url: publicSiteUrl,
      description: aboutEntityDefinition,
      provider: { "@id": `${aboutPageUrl}#organization` },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: publicSiteUrl },
        { "@type": "ListItem", position: 2, name: "About", item: aboutPageUrl },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: aboutPageFaqs.map(({ question, answer }) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: { "@type": "Answer", text: answer },
      })),
    },
  ],
};

export const aboutPageStructuredDataJson = JSON.stringify(aboutPageStructuredData);
